const es = {
  code: "es",
  meta: {
    home: {
      title: "Bloom Beauty Concept Hair | Peluquería en Venda do Pinheiro",
      desc: "Especialista en mechas, balayage, coloración, tratamientos, alineación y alisado en Venda do Pinheiro. Reserve su evaluación con Monique Santos.",
    },
    sobre: {
      title: "Sobre Monique Santos | Bloom Beauty Concept Hair",
      desc: "Conozca a Monique Santos, la hairstylist detrás de Bloom Beauty Concept Hair en Venda do Pinheiro. Atención personalizada y salud capilar primero.",
    },
    servicos: {
      title: "Servicios | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Cortes, coloración, mechas y balayage, corrección de color, tratamientos, cronograma capilar, botox, alineación y alisado en Venda do Pinheiro.",
    },
    avaliacao: {
      title: "Evaluación Profesional | Bloom Beauty Concept Hair",
      desc: "Todo comienza con una buena evaluación: diagnóstico del cabello, historial químico, prueba de mecha y plan personalizado. Reserve por WhatsApp.",
    },
    transformacoes: {
      title: "Transformaciones | Bloom Beauty Concept Hair",
      desc: "Resultados reales de mechas, balayage, coloración, alineación y alisado en Bloom Beauty Concept Hair, Venda do Pinheiro.",
    },
    galeria: {
      title: "Galería | Bloom Beauty Concept Hair",
      desc: "El espacio, los detalles y el trabajo de Bloom Beauty Concept Hair en Venda do Pinheiro.",
    },
    contato: {
      title: "Contacto | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Rua Casal dos Ninhos 1B, Venda do Pinheiro. WhatsApp +351 963 085 891. Lun–Vie 09:00–19:00, sáb 09:30–18:00.",
    },
    privacidade: {
      title: "Política de Privacidad | Bloom Beauty Concept Hair",
      desc: "Política de privacidad y protección de datos de Bloom Beauty Concept Hair.",
    },
  },
  nav: {
    home: "Inicio", about: "Sobre", services: "Servicios", transformations: "Transformaciones",
    gallery: "Galería", contact: "Contacto", book: "Reservar Evaluación", menu: "Menú", close: "Cerrar",
  },
  common: {
    learnMore: "Saber más", bookEval: "Reservar evaluación", bookService: "Reservar cita",
    whatsapp: "WhatsApp", instagram: "Instagram", directions: "Cómo llegar", call: "Llamar",
    send: "Enviar solicitud", sending: "Enviando…", viewServices: "Conocer servicios",
    seeTransformations: "Ver transformaciones", seeGallery: "Ver galería", all: "Todos",
    backToServices: "Volver a servicios",
    includedNote: "Sin precios online: cada cabello es único. Los valores se indican tras la evaluación o por WhatsApp.",
    soonGoogle: "Muy pronto — estamos preparando nuestro perfil de Google.",
  },
  home: {
    heroEyebrow: "Bloom Beauty Concept Hair — Venda do Pinheiro",
    heroLines: ["Cabellos que revelan", "tu mejor", "versión."],
    heroText: "Especialista en color, iluminación, tratamientos, alineación y transformación capilar en Venda do Pinheiro.",
    ctaPrimary: "Reservar Evaluación",
    ctaSecondary: "Conocer Servicios",
    scroll: "Desliza para descubrir",
    marquee: ["Mechas & Balayage", "Coloración", "Tratamientos Capilares", "Alineación", "Alisado", "Corte & Acabado"],
    welcome: {
      eyebrow: "Bienvenida a Bloom",
      title: "Un concepto de belleza hecho a tu medida",
      p: "Bloom Beauty Concept Hair nació para ofrecer una experiencia de belleza personalizada, donde cada cabello se evalúa individualmente y cada transformación respeta la identidad, la salud de la fibra y el deseo de cada clienta.",
      tag: "Realzamos tu belleza, revelamos tu esencia.",
    },
    specialties: {
      eyebrow: "Especialidades",
      title: "Lo que podemos hacer por tu cabello",
      sub: "Técnicas personalizadas, productos profesionales y una mirada atenta a la salud de la fibra.",
    },
    monique: {
      eyebrow: "La Hairstylist",
      title: "Conoce a Monique Santos",
      p1: "Detrás de Bloom está Monique Santos, hairstylist apasionada por realzar la belleza y la identidad de cada mujer.",
      p2: "Cada atención comienza con un análisis cuidadoso del cabello, del historial químico, de los objetivos de la clienta y de la salud de la fibra. El objetivo no es solo transformar el look, sino crear resultados bonitos, personalizados y sostenibles.",
      cta: "Conocer a Monique",
    },
    transformations: {
      eyebrow: "Portafolio",
      title: "Transformaciones que hablan por sí solas.",
      p: "Cada cabello tiene una historia. Cada resultado se construye de forma personalizada.",
    },
    experience: {
      eyebrow: "Experiencia Bloom",
      title: "Cada detalle, pensado para ti",
      steps: [
        { n: "01", t: "Evaluación individual", d: "Antes de cualquier técnica, escuchamos tu historia y analizamos tu cabello." },
        { n: "02", t: "Técnica personalizada", d: "Cada servicio se adapta a tu fibra, a tu rostro y a tu estilo de vida." },
        { n: "03", t: "Productos profesionales", d: "Trabajamos con gamas profesionales elegidas para cada necesidad." },
        { n: "04", t: "Cuidado de la salud capilar", d: "La belleza duradera solo existe con fibras sanas — siempre." },
      ],
    },
    evaluation: {
      eyebrow: "Evaluación Profesional",
      title: "Todo comienza con una buena evaluación.",
      p: "Ciertos procedimientos necesitan un análisis profesional antes de cualquier transformación. Así protegemos la salud de tu cabello y garantizamos el resultado adecuado para ti.",
      items: [
        "Diagnóstico del cabello", "Análisis del cuero cabelludo", "Historial químico", "Objetivo de la clienta",
        "Plan personalizado", "Prueba de mecha cuando es necesario", "Estimación de tiempo", "Orientación profesional",
      ],
      cta: "Reservar mi evaluación",
    },
    salon: {
      eyebrow: "El Salón",
      title: "Un espacio creado para cuidarte.",
      p: "Un ambiente acogedor y elegante donde cada detalle fue pensado para convertir tu momento de belleza en una experiencia especial.",
    },
    quote: "Cuidar el cabello es más que estética. Es autoestima, es recordarte a ti misma.",
    final: {
      title: "¿Lista para vivir la experiencia Bloom?",
      p: "Habla directamente con Monique y reserva tu evaluación.",
      cta: "Reservar por WhatsApp",
    },
    quotes: [
      "Cuídate con el mismo cariño que ofreces a los demás.",
      "Tu belleza comienza cuando reconoces tu propio valor.",
      "Un cabello nuevo puede ser el comienzo de una nueva energía.",
      "Reserva un momento para ti. Lo mereces.",
      "Realza tu belleza. Revela tu esencia.",
      "Cuando te sientes bien contigo misma, se nota por fuera.",
      "Florece en tu propia belleza.",
    ],
  },
  about: {
    eyebrow: "Sobre",
    title: "Más que cabello. Una experiencia de cuidado.",
    p1: "Detrás de Bloom Beauty Concept Hair está Monique Santos, hairstylist apasionada por realzar la belleza y la identidad de cada mujer que se sienta en su silla.",
    p2: "Cada atención comienza con un análisis cuidadoso del cabello, del historial químico, de los objetivos de la clienta y de la salud de la fibra. El objetivo no es solo transformar el look, sino crear resultados bonitos, personalizados y sostenibles — que tengan sentido en el día a día.",
    p3: "En Bloom creemos que la verdadera transformación comienza cuando cada mujer se elige, se cuida y se honra. Aquí, cada detalle está pensado para realzar quien ya eres.",
    philosophyTitle: "Mi filosofía",
    philosophy: "Cada mujer posee una belleza única. Mi trabajo es comprender su estilo, su cabello y el resultado que desea alcanzar para crear una transformación que respete su identidad.",
    valuesTitle: "Lo que puedes esperar",
    values: [
      { t: "Escucha verdadera", d: "Tu deseo y tu rutina son el punto de partida de cada propuesta." },
      { t: "Salud capilar primero", d: "Ninguna transformación vale la salud de tu cabello." },
      { t: "Actualización constante", d: "Técnicas y productos en evolución, al servicio de tu cabello." },
      { t: "Transparencia", d: "Evaluación honesta, sin promesas imposibles." },
    ],
    coursesEyebrow: "Formación profesional",
    coursesTitle: "Monique Santos también es formadora",
    coursesText: "Además de los servicios en el salón, Monique también imparte cursos profesionales de tratamientos capilares y alisado.",
    courseHairTreatments: "Curso de Tratamientos Capilares",
    courseStraightening: "Curso de Alisado",
    lorenaEyebrow: "Profesional Bloom",
    lorenaTitle: "Conoce a Lorena",
    lorenaText: "Lorena forma parte del equipo Bloom y está formada profesionalmente en depilación láser y limpieza facial, con una atención dedicada y personalizada.",
    lorenaLaser: "Depilación Láser",
    lorenaSkin: "Limpieza Facial",
    cta: "Hablar con Monique",
    quote: "Tu belleza florece.",
  },
  servicesPage: {
    eyebrow: "Servicios",
    title: "Un menú de cuidado para cada cabello",
    sub: "Explora cada especialidad. Todos los servicios comienzan con escucha y, cuando es necesario, evaluación profesional — por eso no mostramos precios online.",
  },
  services: {
    "cortes-finalizacao": {
      name: "Cortes & Acabado",
      short: "Cortes y styling que respetan tu rostro y el movimiento natural del cabello.",
      desc: "Cortes y acabados pensados para realzar la forma del rostro, el movimiento del cabello y el estilo de cada clienta.",
      items: [
        "Corte de mujer", "Corte + secado", "Corte + brushing", "Corte de hombre",
        "Flequillo / retoque de corte", "Secado sencillo", "Brushing — cabello corto",
        "Brushing — cabello medio", "Brushing — cabello largo",
        "Brushing — cabello extra largo o denso", "Plancha / acabado liso", "Ondas / moldeado",
      ],
      cta: "Reservar cita",
    },
    coloracao: {
      name: "Coloración",
      short: "Colores personalizados que realzan la piel, el estilo y la identidad.",
      desc: "Colores desarrollados de forma personalizada para realzar la piel, el estilo y la identidad de cada clienta.",
      note: "Algunos servicios pueden requerir una evaluación previa.",
      items: [
        "Coloración de raíz", "Coloración completa — cabello corto", "Coloración completa — cabello medio",
        "Coloración completa — cabello largo", "Coloración — cabello extra largo o denso",
        "Matiz / Gloss", "Baño de brillo", "Cobertura de canas", "Coloración + corte + brushing",
      ],
      cta: "Reservar cita",
    },
    "mechas-balayage": {
      name: "Iluminaciones, Mechas & Balayage",
      short: "Iluminación a medida: del babylight sutil al rubio total.",
      desc: "Iluminaciones creadas según el corte, el tono de piel, la base natural del cabello y el objetivo de la clienta.",
      note: "Las transformaciones de color pueden requerir evaluación y prueba de mecha.",
      items: [
        "Mechas parciales", "Mechas completas", "Balayage", "Balayage Premium",
        "Contour / Face Framing", "Iluminación parcial", "Rubio total", "Babylights",
        "Mechas + matiz + brushing",
      ],
      cta: "Reservar evaluación",
    },
    "correcao-de-cor": {
      name: "Corrección de Color",
      short: "Recuperar, equilibrar y reconstruir el color con seguridad.",
      desc: "Corregir un color es un proceso técnico que exige diagnóstico, estrategia y respeto por la fibra capilar. Cada caso se estudia individualmente.",
      note: "Los servicios complejos de corrección deben evaluarse individualmente.",
      items: [
        "Corrección de color sencilla", "Corrección de color media", "Corrección de color compleja",
        "Decoloración global", "Eliminación de pigmento", "Transformación de color", "Corrección + reconstrucción",
      ],
      cta: "Reservar evaluación",
    },
    "tratamentos-capilares": {
      name: "Tratamientos Capilares",
      short: "Hidratación, nutrición y reconstrucción para un cabello visiblemente sano.",
      desc: "Rituales de tratamiento elegidos según la necesidad real de tu cabello — porque ninguna fibra es igual a otra.",
      items: [
        "Hidratación", "Nutrición", "Reconstrucción", "Tratamiento anti-frizz", "Detox capilar",
        "Cauterización", "Reconstrucción intensiva", "Tratamiento premium", "Tratamiento + brushing",
      ],
      highlights: [
        { t: "Hidratación", d: "Reposición de agua para fibras suaves y flexibles." },
        { t: "Nutrición", d: "Reposición de lípidos para brillo y disciplina." },
        { t: "Reconstrucción", d: "Reposición de masa y proteínas para fuerza y estructura." },
      ],
      cta: "Reservar cita",
    },
    "cronograma-capilar": {
      name: "Cronograma Capilar",
      short: "Un plan de sesiones pensado para la recuperación de tu cabello.",
      desc: "Un programa de cuidado secuencial que combina hidratación, nutrición y reconstrucción en la medida exacta de tu fibra.",
      items: ["Cronograma de 3 sesiones", "Cronograma de 4 sesiones", "Cronograma Premium", "Sesión individual"],
      process: ["Evaluación", "Diagnóstico", "Plan personalizado", "Sesiones", "Mantenimiento"],
      cta: "Reservar evaluación",
    },
    "botox-alinhamento": {
      name: "Botox & Alineación",
      short: "Fibras alineadas, brillantes y sin frizz — con tecnología Bloom.",
      desc: "Del botox capilar a la Realineación Bloom: tecnologías de alineación que devuelven disciplina, brillo y suavidad, respetando la salud de la fibra.",
      note: "Las opciones varían según el largo y la densidad del cabello — definidos en la evaluación.",
      items: ["Botox capilar", "Botox Premium", "Sellado", "Alineación", "Tratamiento anti-frizz"],
      cta: "Reservar evaluación",
    },
    "progressiva-alisamentos": {
      name: "Progresiva & Alisados",
      short: "Liso natural, con movimiento y sin frizz, todos los días.",
      desc: "Cabello alineado, brillante, suave y sin frizz, todos los días. La técnica adecuada — progresiva, alisado orgánico o premium — se elige tras evaluar la fibra.",
      note: "Servicios separados por largo y densidad — valores solo tras la evaluación.",
      items: ["Progresiva", "Alisado orgánico", "Alisado Premium", "Realineación Bloom"],
      cta: "Reservar evaluación",
    },
    "depilacao-a-laser": {
      name: "Depilación Láser",
      short: "Sesiones de depilación láser realizadas por Lorena.",
      desc: "Un servicio personalizado para quienes buscan una reducción progresiva del vello con seguimiento profesional.",
      professional: "Con Lorena",
      note: "El protocolo y la frecuencia de las sesiones se definen individualmente tras una evaluación.",
      items: ["Evaluación inicial", "Plan de sesiones personalizado", "Depilación láser por zonas", "Seguimiento entre sesiones"],
      cta: "Reservar con Lorena",
      waMessage: "¡Hola! Vi la web de Bloom y me gustaría recibir información o reservar depilación láser con Lorena.",
    },
    "limpeza-de-pele": {
      name: "Limpieza Facial",
      short: "Cuidado facial personalizado realizado por Lorena.",
      desc: "Una experiencia de cuidado facial centrada en la limpieza, preparación y confort de la piel, adaptada a las necesidades de cada cliente.",
      professional: "Con Lorena",
      items: ["Evaluación de la piel", "Higienización", "Limpieza y cuidado facial", "Mascarilla facial", "Finalización y orientación de cuidados"],
      cta: "Reservar con Lorena",
      waMessage: "¡Hola! Vi la web de Bloom y me gustaría recibir información o reservar una limpieza facial con Lorena.",
    },
    avaliacao: {
      name: "Evaluación Profesional",
      short: "El punto de partida de cualquier transformación segura.",
      desc: "Diagnóstico completo del cabello y del cuero cabelludo, con prueba de mecha incluida cuando es necesario.",
    },
  },
  avaliacaoPage: {
    eyebrow: "Evaluación Profesional",
    title: "Todo comienza con una buena evaluación.",
    p: "Antes de cualquier transformación de color, alisado o tratamiento intensivo, analizamos tu cabello en detalle. Es este cuidado el que hace que los resultados sean bonitos, seguros y duraderos.",
    itemsTitle: "Lo que analizamos",
    items: [
      { t: "Condición de la fibra", d: "Elasticidad, porosidad, fuerza y nivel de daño." },
      { t: "Cuero cabelludo", d: "Observación del estado general del cuero cabelludo." },
      { t: "Historial químico", d: "Coloraciones, decoloraciones y alisados anteriores." },
      { t: "Objetivo de la clienta", d: "El resultado que deseas y lo que es viable lograr." },
      { t: "Técnica y etapas", d: "Definición de la técnica, del tiempo y de las posibles fases." },
      { t: "Prueba de mecha", d: "Siempre que sea necesario, antes de procedimientos químicos." },
      { t: "Mantenimiento", d: "Orientaciones para mantener el resultado en casa." },
    ],
    cta: "Reservar evaluación por WhatsApp",
  },
  transformationsPage: {
    eyebrow: "Transformaciones",
    title: "Transformaciones que hablan por sí solas.",
    p: "Resultados reales, construidos de forma personalizada. Cada cabello tiene una historia — estas son algunas.",
    filters: { all: "Todas", antesDepois: "Antes & Después", coloracao: "Coloración", balayage: "Balayage", progressiva: "Progresiva", cortes: "Cortes" },
    slider: { before: "Antes", after: "Después" },
    captions: {
      balayage: "Balayage",
      progressiva: "Progresiva Orgánica",
      corteBob: "Corte Bob Corto Invertido",
      colocacao: "Colocación",
      loiro: "Rubio",
      ruiva: "Coloración Cobriza",
      videoLoiro: "Rubio — sin filtro",
      videoProg: "Progresiva Orgánica",
      videoRuiva: "Coloración Cobriza",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  galleryPage: {
    eyebrow: "Galería",
    title: "El universo Bloom en imágenes",
    p: "El espacio, los detalles, los trabajos y la esencia de Bloom Beauty Concept Hair.",
    tags: { all: "Todo", coloracao: "Coloración", balayage: "Balayage", progressiva: "Progresiva", cortes: "Cortes" },
    captions: {
      balayage: "Balayage",
      progressiva: "Progresiva Orgánica",
      corteBob: "Corte Bob Corto Invertido",
      colocacao: "Colocación",
      loiro: "Rubio",
      ruiva: "Coloración Cobriza",
      videoLoiro: "Rubio — sin filtro",
      videoProg: "Progresiva Orgánica",
      videoRuiva: "Coloración Cobriza",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  contactPage: {
    eyebrow: "Contacto",
    title: "¿Hablamos sobre tu cabello?",
    p: "Estamos en Venda do Pinheiro, con las puertas abiertas para ti. Escríbenos por WhatsApp, Instagram o a través del formulario.",
    addressTitle: "Dirección",
    phoneTitle: "Teléfono / WhatsApp",
    hoursTitle: "Horario",
    hoursWeek: "Lunes a viernes",
    hoursWeekTime: "09:00 – 19:00",
    hoursSat: "Sábado",
    hoursSatTime: "09:30 – 18:00",
    formTitle: "Enviar solicitud",
    form: {
      name: "Nombre", namePh: "Tu nombre",
      phone: "Teléfono", phonePh: "+351 …",
      email: "Email", emailPh: "tuemail@ejemplo.com",
      service: "Servicio de interés",
      message: "Mensaje", messagePh: "Cuéntanos qué buscas…",
      submit: "Enviar solicitud",
      success: "¡Solicitud enviada! Responderemos lo antes posible. Si lo prefieres, habla con nosotros ahora por WhatsApp.",
      error: "No se pudo enviar. Inténtalo de nuevo o escríbenos por WhatsApp.",
      required: "Por favor, completa tu nombre y mensaje.",
    },
    serviceOptions: ["Corte", "Coloración", "Mechas", "Balayage", "Corrección de Color", "Tratamiento", "Cronograma", "Botox", "Alineación", "Progresiva", "Evaluación", "Otro"],
    whatsappCta: "Hablar por WhatsApp",
    googleCta: "Valóranos en Google",
    googleTitle: "Bloom en Google",
    googleRating: "★★★★★ 5,0 · 2 reseñas",
    googleNote: "Consulta las reseñas reales en nuestro perfil oficial o deja la tuya.",
    viewReviews: "Ver reseñas",
    leaveReview: "Dejar una reseña ⭐",
  },
  assistant: {
    name: "Asistente Bloom",
    status: "En línea",
    greeting: "¡Hola! 🌸 Bienvenida a Bloom Beauty Concept Hair. ¿Cómo puedo ayudarte?",
    placeholder: "Escribe tu mensaje…",
    whatsapp: "Hablar con Monique por WhatsApp",
    options: [
      { id: "eval", label: "Quiero reservar una evaluación" },
      { id: "services", label: "Quiero conocer los servicios" },
      { id: "mechas", label: "Tengo dudas sobre mechas" },
      { id: "progressiva", label: "Quiero saber sobre la progresiva" },
      { id: "treatments", label: "Quiero saber sobre tratamientos" },
      { id: "location", label: "¿Dónde está el salón?" },
      { id: "hours", label: "¿Cuál es el horario?" },
    ],
    answers: {
      eval: "¡Con mucho gusto! La evaluación profesional es el primer paso: analizamos la condición de la fibra, el cuero cabelludo, el historial químico y tu objetivo — con prueba de mecha cuando es necesario. ¿Te paso con Monique por WhatsApp para reservar?",
      services: "Trabajamos con Cortes & Acabado, Coloración, Iluminaciones, Mechas & Balayage, Corrección de Color, Tratamientos Capilares, Cronograma Capilar, Botox & Alineación y Progresiva & Alisados. Puedes explorar cada especialidad en la página de Servicios.",
      mechas: "Las iluminaciones y mechas se crean según tu corte, tono de piel, base natural y objetivo. Las transformaciones de color pueden requerir evaluación y prueba de mecha — así garantizamos un resultado bonito y saludable.",
      progressiva: "La progresiva y los alisados dejan el cabello alineado, brillante y sin frizz. La técnica ideal depende del largo, la densidad y la condición de la fibra — por eso todo comienza con una evaluación.",
      treatments: "Tenemos hidratación, nutrición, reconstrucción, detox capilar, cauterización y tratamientos premium. En la evaluación vemos exactamente lo que tu cabello necesita — agua, lípidos o proteínas.",
      location: "Estamos en Rua Casal dos Ninhos 1B, Venda do Pinheiro, 2665-536. En la página de Contacto encontrarás el botón «Cómo llegar».",
      hours: "Lunes a viernes: 09:00–19:00. Sábado: 09:30–18:00. Domingo: cerrado.",
      price: "Los valores varían según el servicio, el largo, la densidad y la condición del cabello — por eso no publicamos precios. Monique te lo cuenta todo con gusto, por WhatsApp o en una evaluación.",
      fallback: "Para responderte con toda la atención, lo mejor es hablar directamente con Monique. ¿Te paso al WhatsApp?",
    },
    keywords: {
      eval: ["reservar", "reserva", "agendar", "evaluación", "evaluacion", "cita"],
      price: ["precio", "valor", "cuesta", "costo", "cuánto", "cuanto", "tarifa"],
      hours: ["horario", "abierto", "abre", "cierra", "sábado", "sabado", "domingo"],
      location: ["dónde", "donde", "dirección", "direccion", "ubicación", "ubicacion", "llegar"],
      mechas: ["mecha", "balayage", "rubio", "iluminación", "iluminacion", "babylight"],
      progressiva: ["progresiva", "alisado", "liso", "alisar"],
      treatments: ["tratamiento", "hidratación", "hidratacion", "nutrición", "nutricion", "reconstrucción", "reconstruccion", "botox", "cronograma", "frizz"],
      services: ["servicio", "servicios", "corte", "coloración", "coloracion", "color"],
    },
  },
  footer: {
    tagline: "Realzamos tu belleza, revelamos tu esencia.",
    nav: "Navegación", contact: "Contacto", follow: "Síguenos",
    hours: "Lun–Vie 09:00–19:00 · Sáb 09:30–18:00",
    rights: "Todos los derechos reservados.",
    privacy: "Política de Privacidad",
  },
  privacyPage: {
    title: "Política de Privacidad",
    updated: "Última actualización: septiembre de 2026",
    sections: [
      { t: "Datos que recopilamos", d: "Cuando nos contactas a través del formulario o de WhatsApp, recopilamos tu nombre, teléfono, email y tu mensaje, solo para responder a tu solicitud y gestionar reservas." },
      { t: "Cómo los utilizamos", d: "Los datos se utilizan exclusivamente para comunicarnos contigo sobre nuestros servicios. No vendemos ni compartimos tus datos con terceros con fines de marketing." },
      { t: "Conservación", d: "Los datos se conservan solo el tiempo necesario para gestionar tu solicitud y la relación de clienta." },
      { t: "Tus derechos", d: "Puedes solicitar acceso, rectificación o eliminación de tus datos en cualquier momento, llamando al +351 963 085 891 o por Instagram @monique_santoshairstylist." },
      { t: "Cookies", d: "Este sitio web solo utiliza herramientas de análisis anónimas para mejorar la experiencia de navegación." },
    ],
  },
  notFound: { title: "Página no encontrada", p: "La dirección que buscas no existe o ha sido movida.", cta: "Volver al inicio" },
  waDefault: "¡Hola Monique! Vi el sitio web de Bloom Beauty Concept Hair y me gustaría obtener información/reservar una evaluación.",
  waEval: "¡Hola Monique! Vi el sitio web de Bloom y me gustaría reservar una evaluación profesional.",
};

export default es;
